<template>
  <div class="col-lg-10 col-12 ">
    <Loader v-if="enableLoader"/>
    <div v-if="!showAlta && !enableLoader">
      <span v-if="permisoNewOrEdit" class="link pointer" @click="altaPolitica()">
        <b style="margin-bottom: 30px;">
          <i class="icon-report-add"></i>
          {{$t('language.posadasCorporate.politicasViaje.altaPolViaje')}}
        </b>
      </span>
      <b-table 
          show-empty 
          striped 
          responsive 
          :fields="fields" 
          :items="items" 
          :empty-text="$t('language.posadasCorporate.politicasViaje.noRegistros')"
          :current-page="currentPage" 
          :per-page="perPage">

        <template slot="[confirm]" slot-scope="data" v-html="data.value"></template>
        <span slot="[options]" slot-scope="data" v-html="data.value"></span>

        <template v-slot:cell(confirm)="row">
          <span class="link cursor-pointer"
            @click.prevent="$bvModal.show('detallePolitica')">{{ row.value}}</span>
        </template>

        <template v-slot:cell(options)="row">
          <i @click.prevent="modalDetallePolitica(row.item.politicaKey)" v-b-popover.hover.top="$t('language.posadasCorporate.politicasViaje.detallePolViaje')"
            class="link pointer icon-avanzada icon-doc-detail"></i>
          <i v-if="permisoNewOrEdit" @click="editarPolitica(row.item.politicaKey, row.item.politicaValue)" v-b-popover.hover.top="$t('language.posadasCorporate.politicasViaje.EditPolViaje')"
            class="link pointer icon-avanzada icon-edit"></i>
          <i v-if="permisoNewOrEdit" @click="showModalEliminar(row)" v-b-popover.hover.top="$t('language.posadasCorporate.politicasViaje.delPolViaje')"
            class="link pointer icon-avanzada icon-trash"></i>
        </template>

      </b-table>

      <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage"
        align="right" size="sm">
      </b-pagination>
    </div>

    <!-- Acción nuevo / editar plolíticas de viaje -->
    <div class="datos-politicas-viaje" v-if="showAlta">
      <h5 class="tab-accion-titulo">{{title}}</h5>
      <form @submit.prevent="">
        <div class="datos">
          <!-- Alta de políticas de viaje -->
        <Loader v-if="banLoaderAlta"/>
          <div v-if="!banLoaderAlta" class="dato">
            <div class="datoBody">
              <!-- Datos de política -->
              <div class="campos">
                <p class="tituloDatos" v-if="altaPoliticasViaje.datosPoliticas"
                  :class="(altaPoliticasViaje.iconoActivo == 0) ? 'camposActive' : ''"
                  @click="(altaPoliticasViaje.iconoActivo == 0) ? altaPoliticasViaje.iconoActivo = 100 : altaPoliticasViaje.iconoActivo = 0"
                  v-b-toggle="'datosPoliticas'" accordion="accordion-politicas" role="tabpanel">
                  <i class="icon-report"></i>
                  {{$t('language.posadasCorporate.politicasViaje.datosPol')}} <i id="tooltip-politica" class="icon-info PC-color--colorBase3"></i>
                  <i class="navi icon-up"
                    :class="(altaPoliticasViaje.iconoActivo == 0) ? '' : 'oculto'"></i>
                  <i class="navi icon-navigate-down"
                    :class="(altaPoliticasViaje.iconoActivo == 0) ? 'oculto' : ''"></i>
                </p>
                <p class="tituloDatosEditar" v-if="!altaPoliticasViaje.datosPoliticas"
                  @click="(altaPoliticasViaje.iconoActivo == 0) ? altaPoliticasViaje.iconoActivo = 100 : altaPoliticasViaje.iconoActivo = 0"
                  v-b-toggle="'datosPoliticas'">
                  <i class="icon-check-rounded-fill"></i>
                  {{$t('language.posadasCorporate.politicasViaje.datosPol')}} <i id="tooltip-politica" class="icon-info PC-color--colorBase3"></i>
                  <span class="editarDatos"
                    @click="[altaPoliticasViaje.datosPoliticas = true]">{{$t('language.posadasCorporate.politicasViaje.editar')}}</span>
                </p>

                <b-popover target="tooltip-politica" :title="$t('language.posadasCorporate.politicasViaje.tooltip.title')"
                  triggers="hover focus" placement="top" customClass="PC-popover"
                  :content="$t('language.posadasCorporate.politicasViaje.tooltip.body')">
                </b-popover>

                <b-collapse class="datos" id="datosPoliticas" visible
                  accordion="accordion-politicas" role="tabpanel">
                  <!-- Nombre de política -->
                  <div class="row">
                    <div class="form-element col-lg-8">
                      <label for="">{{$t('language.posadasCorporate.politicasViaje.nombrePol')}}*</label>
                      <input class="mayuscula" type="text" v-model="altaPoliticasViaje.nombrePolitica" maxlength="30" @keyup="altaPoliticasViaje.nombrePolitica = globalFunctions.validText1(altaPoliticasViaje.nombrePolitica)">
                    </div>
                  </div>
                  <!-- Conceptos incluídos -->
                  <div class="row">
                    <div class="form-element col-lg-8">
                      <label for="">{{$t('language.posadasCorporate.politicasViaje.conceptosIncluidos')}}</label>
                      <div class="row">

                        <div v-for="(list, index) in conceptosIncluidos" :key="'editCI_' + index" class="col-12 col-lg-6">
                          <label :for="list.descripcion">
                            <input type="checkbox" :id="list.itemId" v-model="list.value" @click="countCaracters()">
                            <span class="fw-normal">{{ list.descripcion}}</span>
                          </label>
                        </div>
                        
                      </div>
                    </div>
                  </div>

                  <!-- Gastos permitidos -->
                  <div class="row">
                    <div class="form-element col-lg-12">
                      <label for="">{{$t('language.posadasCorporate.politicasViaje.gastosPermitidos')}}</label>
                    </div>

                    <div v-for="gpi in gastosIncluidosInput" :key="gpi.itemId" class="form-element col-lg-4">
                      <label>{{gpi.descripcion}}</label>
                      <input v-if="gpi.itemId != 12 && gpi.itemId != 13 && gpi.itemId != 14"
                        type="text"
                        v-model="gpi.value"
                        :placeholder="gpi.placeholder"
                        @keyup="countCaracters()"
                        maxlength="5">

                        <cleave v-if="gpi.itemId == 12"
                          maxlength="8"
                          v-model="monto"
                          :options="options.number">
                        </cleave>

                        <input v-if="gpi.itemId == 13"
                          type="text"
                          v-model="gpi.value"
                          :placeholder="gpi.placeholder"
                          @keyup="maskPercent($event, gpi)"
                          maxlength="6"
                          v-onlyNumbers>

                        <input v-if="gpi.itemId == 14"
                          type="text"
                          maxlength="5"
                          v-model="gpi.value"
                          @keyup="countCaracters()"
                          v-onlyNumbers>


                    </div>

                    <div v-for="gpa in gastosIncluidosArea" :key="gpa.itemId" class="form-element col-lg-12">
                      <label>{{gpa.descripcion}}</label>
                      <textarea name="" cols="30" rows="4" v-model="gpa.value" :placeholder="gpa.placeholder" @keyup="countCaracters(), gpa.value = globalFunctions.validText2(gpa.value)" ></textarea>
                      <span v-if="(contCaracRequired>=0&&contCaracRequired<=255?true:false)" class="notas">{{255-contCaracRequired}} {{$t('language.posadasCorporate.politicasViaje.caractRestantes')}}</span>
                      <span v-else class="notas" style="color:red;" >{{$t('language.posadasCorporate.politicasViaje.text4')}} {{contCaracRequired-255}} {{$t('language.posadasCorporate.politicasViaje.text4_1')}}</span>
                    </div>
                    <div class="col-lg-12">
                      <label class="notas">* {{$t('language.posadasCorporate.politicasViaje.camposRequeridos')}}</label>
                    </div>
                  </div>
                  <!-- Boton -->
                  <div v-if="banExistUser" class="row">
                    <div class="col-12 col-lg-6 botonesInfo ml-auto" v-b-toggle="'datosPoliticas'"
                      v-b-toggle.asignacionPoliticas>
                      <button class="button"
                        @click="[altaPoliticasViaje.iconoActivo = 1, altaPoliticasViaje.datosPoliticas = false]"
                        :disabled="isDisabledPoliticas || isSelectCIorGP">{{$t('language.posadasCorporate.politicasViaje.continuarAsigPol')}}</button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Asignación de políticas -->
              <div v-if="banExistUser" class="campos">
                <p class="tituloDatos" v-if="altaPoliticasViaje.asignacionPoliticas"
                  :class="(altaPoliticasViaje.iconoActivo == 1) ? 'camposActive' : ''"
                  @click="(altaPoliticasViaje.iconoActivo == 1) ? altaPoliticasViaje.iconoActivo = 100 : altaPoliticasViaje.iconoActivo = 1"
                  v-b-toggle="'asignacionPoliticas'" accordion="accordion-politicas"
                  role="tabpanel">
                  <i class="icon-politics"></i>
                  {{$t('language.posadasCorporate.politicasViaje.asigPol')}}
                  <i class="navi icon-up"
                    :class="(altaPoliticasViaje.iconoActivo == 1) ? '' : 'oculto'"></i>
                  <i class="navi icon-navigate-down"
                    :class="(altaPoliticasViaje.iconoActivo == 1) ? 'oculto' : ''"></i>
                </p>
                <p class="tituloDatosEditar" v-if="!altaPoliticasViaje.asignacionPoliticas"
                  @click="(altaPoliticasViaje.iconoActivo == 1) ? altaPoliticasViaje.iconoActivo = 100 : altaPoliticasViaje.iconoActivo = 1"
                  v-b-toggle="'asignacionPoliticas'">
                  <i class="icon-check-rounded-fill"></i>
                  {{$t('language.posadasCorporate.politicasViaje.asigPol')}}
                  <span class="editarDatos"
                    @click="[altaPoliticasViaje.asignacionPoliticas = true]">{{$t('language.posadasCorporate.politicasViaje.editar')}}</span>
                </p>

                <b-collapse class="datos" id="asignacionPoliticas" visible
                  accordion="accordion-politicas" role="tabpanel">
                  <div class="row">
                    <!-- Asignar a todos los usuarios -->
                    <div class="col-12">
                      <label class="m-0 radio" for="asignaTodos">
                        <input type="radio" id="asignaTodos" class="hidden" value="allUsers"
                          v-model="altaPoliticasViaje.asignaPolitica">
                        <span class="label"></span><span>{{$t('language.posadasCorporate.politicasViaje.asigPolAllUser')}}</span>
                      </label>
                      <div class="row" v-if="altaPoliticasViaje.asignaPolitica==='allUsers'">
                        <div class="col-12">
                          <p style="padding-left: 27px;">{{$t('language.posadasCorporate.politicasViaje.text1')}}</p>
                        </div>
                      </div>
                    </div>
                    <!-- Asignar a usuarios seleccionados -->
                    <div class="col-12">
                      <label class="m-0 radio" for="asignaSeleccionados">
                        <input type="radio" id="asignaSeleccionados" class="hidden"
                          value="selectedUsers" v-model="altaPoliticasViaje.asignaPolitica">
                        <span class="label"></span><span>{{$t('language.posadasCorporate.politicasViaje.text2')}}</span>
                      </label>
                      <div class="row" v-if="altaPoliticasViaje.asignaPolitica==='selectedUsers'">
                        <div class="col-12">
                          <p style="padding-left: 27px;">{{$t('language.posadasCorporate.politicasViaje.text3')}}</p>
                        </div>
                        
                        <div class="col-lg-4" style="padding-left: 40px" v-for="(user, index) in lists" :key="index">
                          <label :for="user.userId">
                            <input type="checkbox" :id="user.userId" v-model="user.value">
                            <span>{{user.userId}}</span>
                          </label>
                        </div>
                        <b-col v-if="perPagePols < politicaList.length" cols="12" lg="12" class="mt-4">
                          <b-pagination
                            v-model="currentPagePols"
                            :total-rows="politicaList.length"
                            :per-page="perPagePols"
                            align="right"
                          >
                          </b-pagination>
                        </b-col>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <Loader v-if="banLoadEditOrNew"/>

        <!-- Botones -->
        <div class="row botones d-flex justify-content-end pt-24" style="margin-bottom: 50px;">
          <div class="col-12 col-lg-4 botonesInfo order-2 order-lg-1">
            <button class="secondary-button"
                @click="reset(),resetFormAltaEdit()">{{$t('language.posadasCorporate.politicasViaje.cancelar')}}</button>
          </div>
          <div class="col-12 col-lg-5 col-xl-4 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
            <button @click="showModalAlta()" class="button" :disabled="isDisabledPoliticasForm || banLoadEditOrNew || isSelectCIorGP">{{(accion=='alta'?$t('language.posadasCorporate.politicasViaje.altaPolViaje2'):$t('language.posadasCorporate.politicasViaje.altaPolViaje3'))}}</button>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal Eliminar -->
    <modal v-show="isModalEliminar" @close="closeModalEliminar" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.politicasViaje.modalEliminarPol.eliminarPolViaje')}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.politicasViaje.modalEliminarPol.body')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button secondary-button order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalEliminar()" aria-label="Close modal">
          {{$t('language.posadasCorporate.politicasViaje.modalEliminarPol.cancelar')}}
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="showModalConfirmar(), isModalConfirmacionEliminar = true"
          aria-label="Close modal">
          {{$t('language.posadasCorporate.politicasViaje.modalEliminarPol.eliminarPol')}}
        </button>
      </template>
    </modal>

    <!-- Modal Heredado -->
    <modal v-show="isModalConfirmar" @close="closeModalConfirmar" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3" style="padding-bottom: 15px;"> <i
            class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.politicasViaje.modalExitoPol.body')}}
        </b>
      </template>
      <template slot="body">

      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalConfirmar()" aria-label="Close modal">
          {{$t('language.posadasCorporate.politicasViaje.modalExitoPol.entendido')}}
        </button>
      </template>
    </modal>

    <!-- Modal Alta -->
    <modal v-show="isModalAlta" @close="closeModalAlta" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3" style="padding-bottom: 15px;"> <i
            class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{modalTitle}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalBody}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalAlta()" aria-label="Close modal">
          {{$t('language.posadasCorporate.politicasViaje.modalAlta.entendido')}}
        </button>
      </template>
    </modal>

    <!-- Ver detalle -->
    <modal v-if="banModalDetallePol" @close="closeModalDetPol" maxWidth="max-w-500 w-100">
      <template slot="header">
        <p class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.politicasViaje.modalDetalle.detallePolViaje')}}</p>
      </template>
      <template slot="body">
        <div class="w-100 align-top">
              <span class="PC-text--size18 PC-text--bold">
                {{ detallePoliticasViaje.nombrePolitica }}
              </span>
              <div>
                <div class="costosTable">
                  <span class="PC-text--size16 PC-text--bold">
                    {{$t('language.posadasCorporate.politicasViaje.modalDetalle.conceptosIncluidos')}}
                  </span>
                </div>
              </div> 
              <div v-if="(detallePoliticasViaje.conceptosIncluidos.length===0?true:false)" class="flex flex-align-end">
                {{ (guiones) }}
              </div>
              <div v-for="(list, index) in detallePoliticasViaje.conceptosIncluidos" :key="index" class="flex flex-align-end">
                <div class="costosTable">
                  <span>
                    &nbsp;&nbsp;- {{ list.descripcion }}
                  </span>
                </div>
              </div>

              <div>
                <div class="costosTableTotal">
                  <span class="PC-text--bold totalCompleto PC-text--size16">{{$t('language.posadasCorporate.politicasViaje.modalDetalle.gastosPermitidos')}}</span><br>
                </div>
              </div>

              <div v-if="(detallePoliticasViaje.gastosPermitidos.length===0?true:false)" class="flex flex-align-end">
                {{ (guiones) }}
              </div>

              <div v-for="li in detallePoliticasViaje.gastosPermitidos" :key="li.itemId">
                <div class="costosTableTotal">
                  <span class="PC-text--bold totalCompleto PC-text--size14">{{ li.descripcion }}:</span><br>
                </div>
                <div class="costosTableTotal">
                  
                  <span v-if="li.special" class="span-multiline text-left">
                    <span class="PC-text--bold PC-text--size14">${{ (li.value===''||li.value===' '||li.value==='  '?guiones:li.value) }}
                      <span v-if="false" class="moneda">MXN</span>
                    </span>
                    <span class="PC-text--size12 PC-color--grayBrownish">{{$t('language.posadasCorporate.politicasViaje.modalDetalle.ivaIncluido')}}</span>
                  </span>

                  <span v-if="!li.special" class="span-multiline text-left">
                    <span class="PC-text--size14">{{ (li.value===''||li.value===' '||li.value==='  '?guiones:li.value) }}{{ (li.itemId===13?'%':'') }}</span>
                  </span>

                </div>
              </div>

            </div>
      </template>
      <template slot="footer">
        <button @click="closeModalDetPol">
          {{$t('language.posadasCorporate.politicasViaje.modalDetalle.entendido')}}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
  import Mixin from '../../../mixins/commons.js';
  import * as GlobalServices from '../../../utils/GlobalServices';
  import * as GlobalFunctions from '../../../utils/GlobalFunctions';
  import axios from 'axios';
  import Modal from './../../addons/Modal.vue';
  import SecureLS from 'secure-ls';
  import Loader from "../../loader/Loader";
  import i18n from '../../../plugins/i18n';
  import Cleave from 'vue-cleave-component';

  export default {
    name: 'PoliticasViaje',
    components: {
      Modal,
      Loader,
      Cleave
    },
    mixins: [Mixin],
    created() {
      if (!GlobalFunctions.validIfGenericUser()) {
        const profile =  this.ls.get('Profile').data;
        if (profile.userType == 'SUPER_ADMIN' || profile.userType == 'ADMIN') {
        const disconunt = this.ls.get('DISCONFIG').data;
          for (const list of disconunt.userPropertiesList) {
            if (list.propertyId == this.propertyId121) {
              this.permisoNewOrEdit = true;
            }
          }
        }
        this.allPoliticasViaje();
      }
    },
    data() {
      return {
        propertyId121: '121',
        banExistUser: true,
        // Reglas para cleave
        options: {
          number: {
          // INI KB46020
            prefix: '$',
            numeral: true,
            numeralPositiveOnly: true,
            noImmediatePrefix: true,
            rawValueTrimPrefix: true,
            numeralIntegerScale: 9,
            numeralDecimalScale: 2,
            tailPrefix: false
             // FIN KB46020
          },
        },
        globalFunctions: GlobalFunctions,
        permisoNewOrEdit: false,
        banLoaderAlta: false,
        banLoadEditOrNew: false,
        policyDetailId: null,
        banModalDetallePol: false,
        guiones: "-------", //no cambiar este valor
        politicaList: [],
        currentPagePols: 1,
        perPagePols: 21,
        isModalEliminar: false,
        isModalConfirmar: false,
        isModalAlta: false,
        modalTitle: i18n.t('language.posadasCorporate.politicasViaje.modalAlta.title1'),
        modalBody: '',
        showAlta: false,
        title: i18n.t('language.posadasCorporate.politicasViaje.title1'),
        perPage: 10,
        totalRows: 1,
        enableLoader: true,
        currentPage: 1,
        ls: new SecureLS({ encodingType: "aes" }),
        responseDelete: false,
        items: [],
        fields: [
          {
            key: 'politicaValue',
            label: i18n.t('language.posadasCorporate.politicasViaje.polViaje')
          },          
          {
            key: 'options',
            label: i18n.t('language.posadasCorporate.politicasViaje.opciones'),
            thStyle: 'width: 15%'
          },
        ],
        // Políticas de viaje
        altaPoliticasViaje: {
          idPolitica: 0,
          iconoActivo: '',
          datosPoliticas: true,
          asignacionPoliticas: true,
          // Datos de políticas
          nombrePolitica: '',

          montoDiario: '',
          descuento: '',
          numeroAlimentos: '',
          comentariosAdicionales: '',

          labelMontoDiario: '',
          labelDescuento: '',
          labelNumeroAlimentos: '',
          labelComentariosAdicionales: '',

          banMontoDiario: false,
          banDescuento: false,
          banNumeroAlimentos: false,
          banComentariosAdicionales: false,

          itemIdMontoDiario: 0,
          itemIdDescuento: 0,
          itemIdNumeroAlimentos: 0,
          itemIdComentariosAdicionales: 0,
          
          asignaPolitica: 'allUsers'
        },
        detallePoliticasViaje: {
          // Datos de políticas
          nombrePolitica: '',
          conceptosIncluidos: [],
          gastosPermitidos: []
        },
        // Conceptos incluidos
        conceptosIncluidos:[],
        gastosIncluidosInput: [],
        gastosIncluidosArea: [],
        contCaracRequired: 0,
        isSelectCIorGP: true,
        monto: '',
      }
    },
    methods: {
      updateGeneralTable(){
        this.enableLoader = true;
        this.items = [];
        setTimeout(() => {
          this.allPoliticasViaje();
        }, 20);
      },
      countCaracters(){
        setTimeout(() => {
          this.isSelectCIorGP = true;
          this.contCaracRequired = 0;
          for (let ci of this.conceptosIncluidos) {
            if (ci.value) {
              this.isSelectCIorGP = false;              
            }
            if (ci.value && ci.commentType === 'GRL') {
              this.contCaracRequired = this.contCaracRequired + ci.contLength;
            }            
          }

          for (let gii of this.gastosIncluidosInput) {
            if (gii.value != '' && gii.value != null && gii.value != '%') {
              this.isSelectCIorGP = false;              
            }
            if (gii.value != null && gii.value != '' && gii.value != '%' && gii.commentType === 'GRL') {
              var a = gii.value.replace('%','');
              this.contCaracRequired = this.contCaracRequired + gii.contLength + a.length;
            }            
          }

          for (let gia of this.gastosIncluidosArea) {
            if (gia.value != null && gia.value != '' && gia.commentType === 'GRL') {
              this.contCaracRequired = this.contCaracRequired + gia.contLength + gia.value.length;
            }            
          }

        }, 20);
      },
      controlOfErrors(error){
        if (error.status == 401) {
          this.sesionClose();
        }
           let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  
  this.$router.push({ name: "Error" });
  
 
} 
 
      },
      newPolViaje(){
        this.banLoadEditOrNew = true;
        //Usuarios
        var listTemUser = [];
        if (this.altaPoliticasViaje.asignaPolitica === 'allUsers') {
          for (let lis of this.politicaList) {
            listTemUser.push(
              {
                userId: lis.userId,
              }
            );
          }
        }

        if (this.altaPoliticasViaje.asignaPolitica === 'selectedUsers') {
          for (let listt of this.politicaList) {
            if (listt.value) {
              listTemUser.push(
              {
                userId: listt.userId,
              }
            );
            }
            
          }
        }
        
        //Conceptos Incluidos
        var listTempConcIncluidos = [];
        for (let list of this.conceptosIncluidos) {
          if (list.value) {
            listTempConcIncluidos.push(
              {
                itemId: list.itemId,
                value: true,
                typeAddItem: "predefinedItems"
              }
            );
          }
        }

        //Gastos Permitidos
        for (let lisGP1 of this.gastosIncluidosInput) {
          if (lisGP1.value != '') {
            listTempConcIncluidos.push(
              {
                itemId: lisGP1.itemId,
                value: lisGP1.value.replace('%', ''),
                typeAddItem: "predefinedItems"
              }
            );
          }
        }

        for (let lisGP2 of this.gastosIncluidosArea) {
          if (lisGP2.value != '') {
            listTempConcIncluidos.push(
              {
                itemId: lisGP2.itemId,
                value: lisGP2.value,
                typeAddItem: "predefinedItems"
              }
            );
          }
        }

        const profile = this.ls.get('Profile').data;
        var data = {
          userId: profile.username,
          userType: profile.userType,
          profileUserId: profile.profileId,
          nameTravelPolicy: this.altaPoliticasViaje.nombrePolitica.toUpperCase(),
          usersModels: listTemUser,
          additionals: listTempConcIncluidos
        };
        if (this.accion === 'alta') {
          GlobalServices._newTravelPolicy(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
            this.modalBody = response.message;
            this.isModalAlta = true;
            this.reset();
            this.resetFormAltaEdit();
            this.banLoadEditOrNew = false;
          }).catch(error => {
            this.controlOfErrors(error);
          });
        }

        if (this.accion === 'editar') {
          data.travelPolicyId = +this.altaPoliticasViaje.idPolitica;
           GlobalServices._updateTravelPolicy(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
            this.modalBody = response.message;
            this.isModalAlta = true;
            this.reset();
            this.resetFormAltaEdit();
            this.banLoadEditOrNew = false;
          }).catch(error => {
            this.controlOfErrors(error);
          });
        }
      },
      closeModalDetPol(){
        this.banModalDetallePol = false;
      },
      sesionClose(){
        GlobalFunctions.localStorageClean();
        this.$router.push({ name: 'Login'})
      },
      modalDetallePolitica(id){
        this.detallePoliticasViaje.conceptosIncluidos = [];
        this.detallePoliticasViaje.gastosPermitidos = [];
        GlobalServices._consultaPolicyDetailById(this.ls.get('Token').data, this.ls.get('Language').data, id).then(response => {
          if (response.status === 200) {
            this.detallePoliticasViaje.nombrePolitica = response.data.description;

            var listTemp1 = [];
            var listTemp2 = [];
            for (var li of response.data.predefinedItems) {
              if ((li.value === 'true' || li.value === true) && li.detail.isFreeText === '0') {
                let conInc1 = {
                  itemId: li.itemId,
                  descripcion: li.description.name,
                  priority: li.priority,
                  isFreeText: li.detail.isFreeText
                }
                listTemp1.push(conInc1);
              }

              if (li.detail.isFreeText === '1') {
                let conInc2 = {
                  itemId: li.itemId,
                  descripcion: li.description.name,
                  value: li.value,
                  priority: li.priority,
                  isFreeText: li.detail.isFreeText,
                  special: false
                }
                if (conInc2.itemId === '12' || conInc2.itemId === 12) {
                  conInc2.special = true;
                }
                listTemp2.push(conInc2);
              }
            }

            this.orderListPolForMenorMayor(listTemp1, 'menorAMayor').then(resp => {
              this.detallePoliticasViaje.conceptosIncluidos = resp;
            });

            this.orderListPolForMenorMayor(listTemp2, 'menorAMayor').then(resp => {
              this.detallePoliticasViaje.gastosPermitidos = resp;
            });

            this.banModalDetallePol = true;
          }
        }).catch(error => {
          this.controlOfErrors(error);
        });
      },
      orderListPolForMenorMayor(listaOrdenar, operador){
        return new Promise ((resolve, reject) => {
          var temporal = null;
          for (var i = 0;i < listaOrdenar.length; i++){
            for (var j = 0; j< listaOrdenar.length-1; j++){
              if (listaOrdenar[j].itemId < listaOrdenar[j+1].itemId && operador === 'mayorAMenor'){
                temporal = listaOrdenar[j];
                listaOrdenar[j] = listaOrdenar[j+1];
                listaOrdenar[j+1] = temporal;
              }
              if (listaOrdenar[j].itemId > listaOrdenar[j+1].itemId && operador === 'menorAMayor'){
                temporal = listaOrdenar[j];
                listaOrdenar[j] = listaOrdenar[j+1];
                listaOrdenar[j+1] = temporal;
              }
            }
          }
          resolve(listaOrdenar);
        });
      },
      allPoliticasViaje() {       
        var _this = this;      
        const profile = _this.ls.get('Profile').data;
        var dataPoliticas = {
          userType: profile.userType,
          contractType: '',
          discountCode: ''
        };
        GlobalServices._consultaAllPoliticasViaje(dataPoliticas, _this.ls.get('Token').data, _this.ls.get('Language').data).then(reponsePoliticas => {
          this.enableLoader = false;
          var data = [];
          for (let pol of reponsePoliticas.data) {
            data.push({ 
                politicaKey: pol.policyCode,
                politicaValue: pol.policyName
                });
          }
          _this.items = data;
        }).catch(error => {
          this.controlOfErrors(error);
        });

      },      
      deleteTravelPolicy(policyId){
        const profile = this.ls.get('Profile').data;

         GlobalServices._deletePoliticasViaje(policyId, this.ls.get('Token').data, this.ls.get('Language').data).then(reponseDeletePoliticas => {
          var response = [];          
          this.responseDelete = reponseDeletePoliticas.data;
        }).catch(error => {
          this.controlOfErrors(error);
        });        
      },
      maskPercent(e, gpi) {
        gpi.value = gpi.value.replace('%','');
       if (gpi.value.length === 0) {
          gpi.value = ''
        } else{
          if (e != undefined && (e.keyCode == 8 || e.key == 'Backspace')) {
            gpi.value = gpi.value.substring(0, gpi.value.length - 1) + '%';
          } else {
            gpi.value = gpi.value + '%'
          }
        }
        gpi.value = (gpi.value=='%'?gpi.value.replace('%',''):gpi.value)
        setTimeout(() => {
          this.countCaracters();
        }, 10);
      },
      showModalEliminar(row) {
        this.ls.set("politicaKey", row.item.politicaKey)        
        this.isModalEliminar = true;
      },
      closeModalEliminar() {
        this.isModalEliminar = false;
      },
      showModalConfirmar() {
        this.isModalConfirmar = true;
        this.isModalEliminar = false;
        this.deleteTravelPolicy(this.ls.get('politicaKey'));
      },      
      closeModalConfirmar() {
        this.isModalConfirmar = false;
        this.updateGeneralTable();
      },
      showModalAlta() {
        this.newPolViaje();
      },
      closeModalAlta() {
        this.isModalAlta = false;
        this.updateGeneralTable();
      },
      servicesForEditOrNew(idd, nombre){
        this.resetFormAltaEdit();
        this.banLoaderAlta = true;
        this.showAlta = true;
        GlobalServices._consultarPredefinedItems(this.ls.get('Token').data, this.ls.get('Language').data).then(response => {
          var listTemp1 = [];
          var listTemp2 = [];
          for (var li of response.data) {
            if (li.isFreeText === '0') {
              let conInc1 = {
                itemId: li.travelPolicyItemId,
                value: false,
                descripcion: li.name,
                priority: li.priority,
                isFreeText: li.isFreeText,
                isTextArea: li.isTextArea,
                lengthFreeText: li.lengthFreeText,
                commentType: li.commentType,
                contLength: li.contLength
              }
              listTemp1.push(conInc1);
            }

            if (li.isFreeText === '1') {
              let conInc2 = {
                itemId: li.travelPolicyItemId,
                value: '',
                descripcion: li.name,
                priority: li.priority,
                isFreeText: li.isFreeText,
                isTextArea: li.isTextArea,
                lengthFreeText: li.lengthFreeText,
                placeholder: '',
                commentType: li.commentType,
                contLength: li.contLength
              }

              if (conInc2.itemId === '12' || conInc2.itemId === 12) {
                conInc2.placeholder = '$0.00';
              }
              if (conInc2.itemId === '13' || conInc2.itemId === 13) {
                conInc2.placeholder = '0%';
              }
              listTemp2.push(conInc2);
            }
          }
          this.orderListPolForMenorMayor(listTemp1, 'menorAMayor').then(resp => {
            this.conceptosIncluidos = resp;
          });
          this.orderListPolForMenorMayor(listTemp2, 'menorAMayor').then(respo => {
            var listTemInput = [];
            var listTemArea = [];
            for (let ll of  respo) {
              if (ll.isTextArea === '0') {
                listTemInput.push(ll);
              }

              if (ll.isTextArea === '1') {
                listTemArea.push(ll);
              }
            }
            this.gastosIncluidosInput = listTemInput;
            this.gastosIncluidosArea = listTemArea;

            GlobalServices._consultarUsuariosPorLogin(this.ls.get('Token').data, this.ls.get('Language').data).then(responde => {
              this.banExistUser = (this.permisoNewOrEdit&&responde.data.length == 0?false:true)
              for (let list of responde.data) {
                this.politicaList.push(
                  {
                    userId: list.userId,
                    value: false
                  }
                );
              }
              if (this.accion === 'alta') {
                //alta
                this.banLoaderAlta = false;
              }

              if (this.accion === 'editar') {
                //editar
                this.altaPoliticasViaje.idPolitica = idd;
                GlobalServices._consultaPolicyDetailById(this.ls.get('Token').data, this.ls.get('Language').data, idd).then(respon => {
                  if (respon.status === 200) {
                    this.altaPoliticasViaje.nombrePolitica = (respon.data.description==undefined||respon.data.description==null?nombre:respon.data.description);

                    for (let preItem of respon.data.predefinedItems) {
                      for (let cI of this.conceptosIncluidos) {
                        if (preItem.itemId === +cI.itemId) {
                          cI.value = (preItem.value===true||preItem.value==='true'?true:false);
                        }
                      }
                      for (let gII of this.gastosIncluidosInput) {
                        if (preItem.itemId === +gII.itemId && preItem.value != '') {
                          gII.value = preItem.value;
                        }
                        if (preItem.itemId == 12) {
                          this.monto = preItem.value
                        }
                        if (preItem.itemId == 13) {
                          this.maskPercent(undefined, preItem);
                        }
                      }
                      for (let gIA of this.gastosIncluidosArea) {
                        if (preItem.itemId === +gIA.itemId && preItem.value != '') {
                          gIA.value = preItem.value;
                        }
                      }
                    }

                    for (let user of respon.data.users) {
                      for (let us of this.politicaList) {
                        if (user.userId === us.userId) {
                          us.value = true;
                          this.altaPoliticasViaje.asignaPolitica = 'selectedUsers'
                        }
                      }
                    }

                    this.countCaracters();
                    this.banLoaderAlta = false;

                  }
                }).catch(error => {
                  this.controlOfErrors(error);
                });
              }
            }).catch(error => {
              this.controlOfErrors(error);
            });
          });
        }).catch(error => {
          this.controlOfErrors(error);
        });
      },
      altaPolitica() {
        this.servicesForEditOrNew(1);
        this.accion = 'alta';
        this.title = i18n.t('language.posadasCorporate.politicasViaje.title1');
        this.modalTitle = i18n.t('language.posadasCorporate.politicasViaje.modalAlta.title1');
      },
      editarPolitica(id, nombre) {
        this.servicesForEditOrNew(id, nombre);
        this.accion = 'editar';
        this.title = i18n.t('language.posadasCorporate.politicasViaje.title2');
        this.modalTitle = i18n.t('language.posadasCorporate.politicasViaje.modalAlta.title2');
      },
      reset() {
        this.showAlta = false;
        this.title = 'Alta de política de viaje';
        this.altaPoliticasViaje.asignaPolitica = 'allUsers';
        this.altaPoliticasViaje.datosPoliticas = true;
        this.altaPoliticasViaje.iconoActivo = 0;
      },
      resetFormAltaEdit(){
        this.altaPoliticasViaje.nombrePolitica = '';
        this.altaPoliticasViaje.idPolitica = 0;

        this.altaPoliticasViaje.montoDiario = '';
        this.altaPoliticasViaje.descuento = '';
        this.altaPoliticasViaje.numeroAlimentos = '';
        this.altaPoliticasViaje.comentariosAdicionales = '';

        this.altaPoliticasViaje.labelMontoDiario = '';
        this.altaPoliticasViaje.labelDescuento = '';
        this.altaPoliticasViaje.labelNumeroAlimentos = '';
        this.altaPoliticasViaje.labelComentariosAdicionales = '';

        this.altaPoliticasViaje.banMontoDiario = false;
        this.altaPoliticasViaje.banDescuento = false;
        this.altaPoliticasViaje.banNumeroAlimentos = false;
        this.altaPoliticasViaje.banComentariosAdicionales = false;

        this.altaPoliticasViaje.itemIdMontoDiario = 0;
        this.altaPoliticasViaje.itemIdDescuento = 0;
        this.altaPoliticasViaje.itemIdNumeroAlimentos = 0;
        this.altaPoliticasViaje.itemIdComentariosAdicionales = 0;

        this.conceptosIncluidos = [];
        this.politicaList = [];
        this.gastosIncluidosInput = [];
        this.gastosIncluidosArea = [];
        this.contCaracRequired = 0;
        this.monto = '';
      },
    },
    computed: {
      lists () {
        const items = this.politicaList
        // Return just page of items needed
        return items.slice(
          (this.currentPagePols - 1) * this.perPagePols,
          this.currentPagePols * this.perPagePols
        )
      },
      isDisabledPoliticas() {
        if (this.altaPoliticasViaje.nombrePolitica.length > 0 &&
          this.contCaracRequired >= 0 && this.contCaracRequired <= 255) {
          return false;
        } else {
          return true;
        }
      },
      isDisabledPoliticasForm() {
        var ban = true;
        if (this.altaPoliticasViaje.asignaPolitica == 'selectedUsers') {
          for (let lu of this.politicaList) {
            if (lu.value) {
              ban = false;
            }
          } 
        }
        if (this.altaPoliticasViaje.asignaPolitica == 'allUsers') {
          ban =  false;
        }
        if (this.altaPoliticasViaje.nombrePolitica.length > 0 &&
          this.altaPoliticasViaje.asignaPolitica.length > 1 &&
          this.contCaracRequired >= 0 && this.contCaracRequired <= 255 &&
          !ban) {
          return false;
        } else {
          return true;
        }
      },
    },
    watch: {
      monto(){
        for (let li of this.gastosIncluidosInput) {
          if (li.itemId == 12) {
            li.value = this.monto;
          }
        }
        this.countCaracters();
      },
    },
    filters: {},
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .datos {
    i {
      font-size: 18px;
    }
    .navi {
      float: right;
    }
    .editarDatos {
      font-size: $font-size-base;
      color: #0c5458;
      float: right;
    }
  }
  .campos {
    border-bottom: 1px solid $colorBase5;
    &:last-child {
      border-bottom: none;
    }
    .datos {
      padding-bottom: 24px;
    }
    .tituloDatos {
      margin: 0;
      color: $grayBrownish;
      font-size: $font-size-large;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }
    .camposActive {
      color: #0c5458;
      font-weight: 500;
    }
    .tituloDatosEditar {
      margin: 0;
      color: #006900;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }
    .cardsInfo {
      background-color: #d1ecf1;
      .nota {
        font-size: $font-size-base;
        color: $grayShadeDark;
      }
      .notaAzul {
        font-size: $font-size-base;
        color: $colorBase2;
        font-weight: 500;
      }
    }
  }
  textarea {
    height: 130px;
  }
</style>